import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div className="footer-design mt-5">
            <div className="container">
                <div className="copyright">
                    <p className="text-white fw-bold py-5"> CopyRight &copy; Developer Riaz hossen</p>
                </div>
            </div>

        </div>
    );
};

export default Footer;